function getVariantCurrent() {

    let productVariantsList = $('.product').data('variants');

    if (productVariantsList.length > 1) {
        let selected = [];

        $('.area-variants select').each(function () {

            selected.push([
                $(this).data('id'),
                $(this).find('option').filter(':selected').val()]);
        });

        for (let i = 0; i < productVariantsList.length; ++i) {

            let variant = productVariantsList[i].variant_ids_list,
                match = true;
            for (let ii = 0; ii < selected.length; ++ii) {
                if (variant[selected[ii][0]] != selected[ii][1]) {
                    match = false;
                }
            }
            if (match) {
                return productVariantsList[i];
            }
        }
    } else {
        return productVariantsList[0];
    }

    return false;
}

function getVariantByIds(variantsIdList) {

    let productVariantsList = $('.product').data('variants');

    for (let i = 0; i < productVariantsList.length; ++i) {

        let idList = productVariantsList[i].variant_ids_list,
            isMatch = true;

        for (let ii = 0; ii < variantsIdList.length; ++ii) {
            if (idList[variantsIdList[ii][0]].length == 0) {
                isMatch = false;
            } else {

                if (parseInt(idList[variantsIdList[ii][0]]) != variantsIdList[ii][1]) {
                    isMatch = false;
                }
            }
        }

        if (isMatch) {
            return productVariantsList[i];
        }
    }

    return false;
}
function updateVariants(clicked) {
    let question,
        element,
        state,
        variantId,
        variantValueId,
        variantids,
        t;

    $('.area-variants select').each(function () {

        variantId = $(this).data('id'),
            variantValueId = parseInt($(this).find('option').filter(':selected').val());

        //loop other variant selectboxes
        variantids = [];
        $('.area-variants select').not("[data-id=" + variantId + "]").each(function () {

            variantids.push([
                $(this).data('id'),
                parseInt($(this).find('option').filter(':selected').val())
            ]);
        });

        $(this).find('option').not('[value=' + variantValueId + ']').each(function () {

            t = getVariantByIds(variantids.concat([[
                variantId,
                $(this).data('id')
            ]]));

            $(this).attr('disabled', t.status == 'disabled'
                ? true
                : false);
        });
    });

    let variant = getVariantCurrent(),
        priceMainOrigin,
        priceMain,
        priceOther,
        priceMainFrom;

    $('.product-variant-sku').html(variant.sku);

    if (parseFloat(variant.price) == 0.00) {

        $('.price .label').addClass('d-none');
        $('.price .main').addClass('d-none');
        $('.price .other').addClass('d-none');
        $('.price .price-none').removeClass('d-none');

    } else {

        $('.price .label').removeClass('d-none');
        $('.price .main').removeClass('d-none');
        $('.price .other').removeClass('d-none');
        $('.price .price-none').addClass('d-none');

        priceMain = variant.price_excl;
        priceMainOrigin = variant.price_excl;
        priceMainFrom = variant.price_from_excl;
        priceOther = variant.price_incl;

        if (config.webshop.type == 'B2C') {
            priceMain = variant.price_incl;
            priceMainOrigin = variant.price_incl;
            priceMainFrom = variant.price_from_incl;
            priceOther = variant.price_excl;
        }

        if ($('.product').data('discount') !== "") {
            priceMain = priceMain * ((100 - parseFloat($('.product').data('discount'))) / 100);
        }
        $('.price .main .amount')
            .attr('data-price', parseFloat(priceMain).toFixed(2))
            .data('price', parseFloat(priceMain).toFixed(2));

        $('.price .main .amount .product-price-span')
            .html(getLocalePrice(priceMain, 0));

        if (priceMainFrom == 0) {
            $('.price .main .amount .price-from-strike').parent().addClass('d-none');
            $('.price-from').parent().addClass('d-none');

            if ($('.product').data('discount') !== "") {
                $('.price .main .amount .price-from-strike').parent().removeClass('d-none');
                $('.price-from').parent().removeClass('d-none');
                $('.price-from').html(getLocalePrice(priceMainOrigin - priceMain));
                $('.price .main .amount .price-from-strike')
                    .html(getLocalePrice(priceMainOrigin, 0));

            }
        } else {
            $('.price .main .amount .price-from-strike').parent().removeClass('d-none');
            $('.price-from').removeClass('d-none');
            $('.price-from').html(getLocalePrice(priceMainFrom - priceMain));
            $('.price .main .amount .price-from-strike')
                .html(getLocalePrice(priceMainFrom, 0));
        }

        if ($('.price .other').length > 0) {
            $('.price .other .amount .product-price-span').html(getLocalePrice(priceOther, 0));
        }
    }

    if (variant.images.length > 0) {
        let image = config.domain + '/media/products/' + variant.images[0].table_item_id + '/' + variant.images[0].image_src;

        $('#image-main').attr('src', image);
        $('#image-main').parents('.carousel__slide').attr('data-src', image);
    } else {
        $('#image-main').attr('src', $('#image-main').data('src'));
    }
}

let changing = false;
let toggleDraggable = false;

function setContent() {

    if ($('#page .area-images')[0] == null) {
        return false;
    }

    if (!changing && !toggleDraggable) {

        changing = true;

        let hasSample = false,
            images = $($('#page .area-images')[0].outerHTML),
            sample;

        if ($('.area-sample').length > 0) {
            sample = $($('#page .area-sample')[0].outerHTML);
            hasSample = true;
            $('#page .area-sample').remove();
        }
        $('#page .area-images').remove();

        if ($(window).width() <= 575) {
            images.insertAfter('#page .area-title');
            if (hasSample) {
                sample.insertAfter('#page .area-usps');
            }

        } else {
            $('#page .columns > .left').prepend(images);
            if (hasSample) {
                $('#page .columns > .left').append(sample);
            }
        }

        changing = false;
    }
}

function setFancybox() {
    let mainCarousel;
    let currentCarousel;

    if ($("#mainCarousel").length == 0) {
        return false;
    }

    if (document.querySelector("#mainCarousel") == null) {
        return false;
    }

    mainCarousel = new Carousel(document.querySelector("#mainCarousel"), {
        Dots: false,

    });

    currentCarousel = mainCarousel;

    if (document.querySelector("#thumbCarousel") == null) {
        return false;
    }
    const thumbCarousel = new Carousel(document.querySelector("#thumbCarousel"), {
        Sync: {
            target: currentCarousel,
            friction: 0,
        },
        Dots: false,
        Navigation: false,
        center: false,
        slidesPerPage: 1,
        infinite: false,
    });
    Fancybox.bind('[data-fancybox="gallery"]', {

    });
}

function setCardMaxHeight(element) {
    let maxHeight = 0;
    $(element).each(function () {
        if ($(this).outerHeight() > maxHeight) {
            maxHeight = $(this).outerHeight();
        }
    });
    $(element).height(maxHeight);
}


$(document).ready(function () {

    $(window).keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    if ($(window).width() <= 768) {

        $(".imagewebwinkel").clone().appendTo(".webimageholder");

    }

    $(document).on('change', '.area-variants select', function () {
        updateVariants();
    });

    if ($('.area-variants select').length > 0) {
        updateVariants();
    }

    let owlRelated = $('.carousel-related').owlCarousel({
        items: 2,
        slideBy: 1,
        margin: 15,
        touchDrag: true,
        pullDrag: true,
        mouseDrag: true,
        dots: true,
        nav: false,
        responsive: {
            768: {
                items: 3,
                margin: 15
            },
            992: {
                items: 4,
                margin: 30
            }
        }

    });

    if ($('.carousel-alternatives').length > 0) {
        let owlAlternative = $('.carousel-alternatives').owlCarousel({
            items: 2,
            slideBy: 1,
            margin: 15,
            touchDrag: true,
            pullDrag: true,
            mouseDrag: true,
            dots: true,
            nav: false,
            responsive: {
                768: {
                    items: 3,
                    margin: 15
                },
                992: {
                    items: 4,
                    margin: 30
                }
            }

        });

        if (typeof document.fonts !== 'undefined' &&
            typeof document.fonts.ready !== 'undefined') {

            document.fonts.ready.then(function () {
                setCardMaxHeight('.card-product-alternative');
            });
        } else {
            setTimeout(function () {
                setCardMaxHeight('.card-product-alternative');
            }, 1500)
        }
    }

    if (typeof document.fonts !== 'undefined' &&
        typeof document.fonts.ready !== 'undefined') {

        document.fonts.ready.then(function () {
            setCardMaxHeight('.card-product-related');
            setCardMaxHeight('.card-product-gift');
        });
    } else {
        setTimeout(function () {
            setCardMaxHeight('.card-product-related');
            setCardMaxHeight('.card-product-gift');
        }, 1500)
    }

    let owlGift = $('.carousel-gift').owlCarousel({
        items: 2,
        slideBy: 1,
        margin: 15,
        touchDrag: true,
        pullDrag: true,
        mouseDrag: true,
        dots: true,
        nav: false,
        responsive: {
            768: {
                items: 3,
                margin: 15
            },
            992: {
                items: 4,
                margin: 30
            }
        }

    });

    if ($('.last-visited').length > 0) {
        let owlLastVisited = $('.carousel-last-visited').owlCarousel({
            items: 2,
            slideBy: 1,
            margin: 15,
            touchDrag: true,
            pullDrag: true,
            mouseDrag: true,
            dots: true,
            nav: false,
            responsive: {
                768: {
                    items: 3,
                    margin: 15
                },
                992: {
                    items: 4,
                    margin: 30
                }
            }

        });

        if (typeof document.fonts !== 'undefined' &&
            typeof document.fonts.ready !== 'undefined') {

            document.fonts.ready.then(function () {
                setCardMaxHeight('.card-product-last-visited');
            });
        } else {
            setTimeout(function () {
                setCardMaxHeight('.card-product-last-visited');
            }, 1500)
        }
    }

    $(document).on('change keyup', '#quantity', function () {

        let pricesGraduated = $('.product').data('prices-graduated'),
            priceIsset = false,
            price,
            priceExcl,
            priceIncl,
            priceMain,
            discountAmount,
            priceOther;

        if (pricesGraduated != 'false' && pricesGraduated != false) {

            for (let i = 0; i < pricesGraduated.length; ++i) {
                if (parseInt(pricesGraduated[i].amount_start) <= $(this).val() &&
                    parseInt(pricesGraduated[i].amount_end) >= $(this).val()) {
                    priceExcl = pricesGraduated[i].price_excl;
                    priceIsset = true;
                }
            }

            if (!priceIsset) {
                priceExcl = pricesGraduated[pricesGraduated.length - 1].price_excl;
            }

            priceExcl = parseFloat(getPrice(priceExcl, 0).replace(",", "."));

            if (config.webshop.prices.display.type == 'incl') {
                priceMain = getPrice(priceExcl, $('.product').data('vatrate'));
                priceOther = getPrice(priceExcl, 0);
            } else {
                priceMain = getPrice(priceExcl, 0);
                priceOther = getPrice(priceExcl, $('.product').data('vatrate'));
            }

            discountAmount = $(this).data('discount');
            if (discountAmount !== undefined && discountAmount > 0 && discountAmount !== "") {
                priceMain = parseFloat(priceMain.replace(',', '.')) * ((100 - parseFloat(discountAmount)) / 100);
                priceMain = getPrice(priceMain, 0);
            }

            let span = $('.price .main .amount span.product-price-span');
            if (span.length > 0) {
                span.html(getCurrency() + " " + priceMain);
            } else {
                $('.price .main .amount').html(getCurrency() + " " + priceMain);
            }


            if ($('.price .other').length > 0) {
                $('.price .other .amount').html(getCurrency() + " " + priceOther);
            }
        }
    });


    $(document).on('change', '.variant-bundle', function () {

        window.location.href = $(this).children("option:selected").data('url');
    });


    if ($('.product-header').length > 0) {
        $(window).scroll(function () {
            if ($(document).scrollTop() > 181) {
                $('.product-header').addClass('active');
            } else {
                $('.product-header').removeClass('active');
            }
        });
    }

    $(window).on('resize', function () {
        setContent();
        setFancybox();
    });

    setContent();
    setFancybox();

    $(document).on('click', '.btn-product-subscribe', function (e) {
        e.preventDefault();

        let parent = $(this).parents('.area-subscribe');

        $.ajax({
            url: config.domain + '/frontend/functions/products_subscribe.php?action=1',
            type: 'POST',
            dataType: 'json',
            data: {
                email: parent.find('#subscribe-email').val(),
                product_id: $('#product_id').val(),
                token: $('#csrf-token').val()
            },
            'success': function (response) {

                $('.area-subscribe .alert').remove();

                let str = `
                <div class="alert alert-${response.message.type}">
                    <button type="button" class="close" data-dismiss="alert">&times;</button >
                    ${response.message.text}
                </div>`;
                $('.area-subscribe .alerts').append(str);

                $('.area-subscribe #subscribe-email').val('');
            }
        });
    });

});